import { MARQUEE_ITEMS } from "@/data/site";

const Marquee = () => (
  <div aria-hidden="true" className="py-10 border-b border-white/10 overflow-hidden select-none">
    <div className="flex w-max animate-marquee gap-0">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0">
          {MARQUEE_ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-playfair italic text-2xl sm:text-3xl text-[#F5F5F0]/25 whitespace-nowrap px-6">
                {item}
              </span>
              <span className="w-2 h-2 rounded-full bg-[#F2C230]/40 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
